import React from 'react';

const NewChannelModal = () => (
  <div id="noChannelPlaceholder">
    <h1 className="newChannelHeader">Create/join a channel to get started.</h1>
  </div>
);

export default NewChannelModal;
